<template>
  <div class="rule-wraper">
    <TxButton class="rule t-btn text-shu" src="anniu" name="领取奖励" @click="showModalHandle">领取奖励</TxButton>
    <TxImage v-if="is_red" src="hongdian" class="reward-hongdian" />
    <TxDialog v-model="is_show">
      <div class="reward-container p-40" style="position: relative">
        <div class="t-s-30 t-white">领取奖励</div>
        <div v-if="isLoading">奖励加载中...</div>
        <div v-else-if="error">
          {{ error }}
        </div>
        <div v-else>
          <div class="f-colum">
            <div class="f-row f-zhu-between f-fu-center">
              <div class="t-3 f-row p-r">
                <TxImage class="m-r-10" src="biao" /> 提取奖励
                <TxImage class="m-l-10" src="wenhao1" @click="is_wenhao_tips = !is_wenhao_tips" />
                <ItemContainer v-if="is_wenhao_tips" src="wenhaotips" class="wenhao-tips">
                  <span>金色格子可提取:<span class="c-gold">金边道具</span>和普通边框道具</span>
                  <span>普通格子可提取:普通边框道具</span>
                </ItemContainer>
              </div>
              <span class="t-3">最多支持领取6个奖励</span>
            </div>
            <div class="beibao-show f-row f-zhu-between f-fu-center p-10">
              <ItemContainer :size="{ width: 85, height: 85 }" src="jin" class="f-center" v-for="c in 2" :key="c">
                <div v-if="state.gold_backpack[c - 1]" class="f-center" @click="
                  handle_show(
                    state.gold_backpack[c - 1].item_id,
                    state.gold_backpack[c - 1].id
                  )
                  ">
                  <TxImage :src="activity_config.item_data[
                      state.gold_backpack[c - 1].item_id
                    ].icon
                    " :size="{ width: 70, height: 70 }" />
                </div>
                <div v-else></div>
              </ItemContainer>

              <ItemContainer src="daojuge80x80" class="f-center" v-for="c in 4" :key="c">
                <div v-if="state.backpack[c - 1]" class="f-center" @click="
                  handle_show(
                    state.backpack[c - 1].item_id,
                    state.backpack[c - 1].id
                  )
                  ">
                  <TxImage :src="activity_config.item_data[state.backpack[c - 1].item_id]
                      .icon
                    " :size="{ width: 70, height: 70 }" />
                </div>
                <div v-else></div>
              </ItemContainer>
            </div>
          </div>
          <div class="jiangli m-t-10">
            <div class="f-row f-zhu-between f-fu-center">
              <div class="t-3 f-row">
                <TxImage class="m-r-10" src="biao" /> 当前抽取
              </div>
              <span class="t-3">点击任意道具可以放置背包</span>
            </div>
            <div class="f-row f-wrap f-zhu-between p-10 y-overflow jiangli-list">
              <template v-for="c in computed_reward_list">
                <ItemContainer v-if="activity_config.item_data[c.item_id].is_gold == null"
                  :size="{ width: 85, height: 85 }" class="p-r f-center m-5" src="daojuge80x80"
                  @click="handle_show(c.item_id, c.id)">
                  <TxImage v-if="c.show_red_dot" src="hongdian" class="reward-item-dot" />
                  <TxImage :src="activity_config.item_data[c.item_id].icon" :size="{ width: 65, height: 65 }" />
                  <div class="t-1 zhedang t-center" v-if="c.status == 1">
                    已添加
                  </div>
                </ItemContainer>
                <ItemContainer v-else class="p-r f-center m-5" src="jin" :size="{ width: 85, height: 85 }"
                  @click="handle_show(c.item_id, c.id)">
                  <TxImage src="hongdian" class="reward-item-dot" v-if="c.show_red_dot" />
                  <TxImage :src="activity_config.item_data[c.item_id].icon" :size="{ width: 65, height: 65 }" />
                  <div class="t-1 zhedang t-center" v-if="c.status == 1">
                    已添加
                  </div>
                </ItemContainer>
              </template>

              <div class="jpdi m-5" v-for="a in 6" :key="a"></div>
            </div>
          </div>
        </div>
        <ItemContainer class="t-white t-s-1 t-center p-5" src="hengdi1" :size="{ width: 606, height: 41 }">
          活动结束后将<span class="t-2">锁定提取奖励</span>中的奖品
        </ItemContainer>
        <div class="f-row tongxiang-hongbao">
          <ItemContainer v-if="state && state.share_award != null" @click="handle_show_together" class="p-r"
            src="tongxiang">
            <TxImage class="p-r-t tongxiang-hongdian" src="hongdian" v-if="state && state.share_award.show_red_dot" />
            <div class="t-1 t-center p-b w-100">同享</div>
          </ItemContainer>
          <ItemContainer class="p-r m-l-10" src="hongbao1" v-if="
            login_status &&
            !!Number(state?.red_packet?.red_packet_amount || 0)
          " @click="receiveHongbao">
            <TxImage class="p-r-t" src="hongdian" v-if="!state?.red_packet?.is_received" />
            <div class="t-1 t-center w-100 tixian" :class="{
              noReveive: !canReveive,
            }">
              {{
                canReveive
                  ? state?.red_packet?.is_received
                    ? '已领'
                    : '提现'
                  : reveiveDataFormat2 + '可领'
              }}
            </div>
          </ItemContainer>>
        </div>
      </div>
    </TxDialog>

    <TxDialog v-model="is_tips">
      <div class="tips-container t-white f-colum f-fu-center">
        <div class="tips-header f-row f-fu-center p-l-20">
          <ItemContainer v-if="computed_tips.is_gold == 1" class="m-r-10 f-center" src="jin"
            :size="{ width: 80, height: 80 }">
            <TxImage :src="computed_tips.icon" :size="{ width: 70, height: 70 }" />
          </ItemContainer>
          <ItemContainer v-else class="m-r-10 f-center" src="jpdi" :size="{ width: 80, height: 80 }">
            <TxImage :src="computed_tips.icon" :size="{ width: 70, height: 70 }" />
          </ItemContainer>
          <span class="tips-name">{{ computed_tips.name }}</span>
        </div>
        <ItemContainer src="xian"></ItemContainer>
        <div class="tips-content">
          <template v-if="tips_info">
            <div v-for="cell in tips_info" class="wuqiTips-item">
              <template v-for="item in cell">
                <template v-if="item.divType == ''">
                  <div :class="item.data.class" :style="methodsStyle(item.data.style)">
                    {{ item.text }}
                  </div>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            {{ computed_tips.desc }}
          </template>
        </div>
        <div class="reward-btn">
          <template v-if="computed_tips.is_gold == 1">
            <TxButton v-if="computed_status == 1" src="anniu_2" name="取出背包" class="t-btn" @click="handle_un_set">取出
            </TxButton>
            <TxButton v-else-if="is_gold_full" src="anniu_2" name="金格已满" class="t-btn">金格已满</TxButton>
            <TxButton v-else src="anniu_2" name="放入背包" class="t-btn" @click="handle_set">
              放入背包
            </TxButton>
          </template>
          <template v-else>
            <TxButton v-if="computed_status == 1" src="anniu_2" name="取出背包" class="t-btn" @click="handle_un_set">取出
            </TxButton>
            <TxButton v-else-if="is_full && is_gold_full" src="anniu_2" name="背包已满" class="t-btn">背包已满</TxButton>
            <TxButton v-else src="anniu_2" name="放入背包" class="t-btn" @click="handle_set">
              放入背包
            </TxButton>
          </template>
        </div>
      </div>
    </TxDialog>

    <TxDialog v-model="Dialog.success">
      <ItemContainer src="db_9" class="p-50 f-colum f-zhu-center f-fu-center">
        <h2 class="t-white t-center tongxiang-title t-s-30">同享成功</h2>
        <div class="tongxiang-container f-center">
          <ItemContainer src="dikuang" class="f-center">
            <TxImage :src="activity_config.item_data[state.share_award.item_id].icon"
              :size="{ width: 120, height: 120 }" />
          </ItemContainer>
          <span>{{
            activity_config.item_data[state.share_award.item_id].name
            }}</span>
        </div>
        <ItemContainer src="wenzid" class="t-white t-center t-s-20 f-row f-zhu-center f-fu-center">
          <span class="t-2">{{ state.share_award.claimed_account }}</span>领到了您的同享奖励
        </ItemContainer>
      </ItemContainer>
    </TxDialog>

    <TxDialog v-model="Dialog.fail">
      <ItemContainer src="db_9" class="p-50 f-colum f-zhu-center f-fu-center">
        <h2 class="t-white t-center tongxiang-title t-s-30">同享失败</h2>
        <div class="tongxiang-container f-center">
          <ItemContainer src="dikuang" class="f-center">
            <TxImage :src="activity_config.item_data[state.share_award.item_id].icon"
              :size="{ width: 120, height: 120 }" />
          </ItemContainer>
          <span>{{
            activity_config.item_data[state.share_award.item_id].name
            }}</span>
        </div>
        <ItemContainer src="wenzid_1" class="t-white t-center">
          <span class="t-2">可恶居然无人在意</span>
        </ItemContainer>
      </ItemContainer>
    </TxDialog>
  </div>
</template>
<script setup>
import { get_award_list } from '@utils/api';
import { useAsyncState } from '@vueuse/core';
import { onMounted, shallowRef } from 'vue';
import {
  set_bonus,
  get_red_data,
  post_set_share_reward_red_dot,
  get_set_last_time,
} from '@utils/api';
import eventEmitter from '@utils/event';
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
const { reveiveDataFormat2, canReveive, activity_config } =
  inject('GlobalStore');
const { login_status, error_codemsg, init_data } = inject('GlobalData');
import encodeText from '../utils/encodText';
const { isWeChat, isMiniProgram } = useWeChatEnv();

const is_show = shallowRef(false);
const is_tips = shallowRef(false);
const tips_id = shallowRef(null);
const add_id = shallowRef(null);
const { state, isReady, isLoading, error, execute } = useAsyncState(
  () => get_award_list().then((t) => t.data),
  null,
  { immediate: false }
);
function methodsStyle(style) {
  let obj = {};
  if (style.color) {
    obj.color = style.color;
  }
  return obj;
}

const Dialog = reactive({
  success: false,
  fail: false,
});

const computed_tips = computed(() => {
  return activity_config.value.item_data[tips_id.value];
});

const computed_status = computed(() => {
  let v = add_id.value;
  let res = 0;
  state.value.normal_award_list.map((item) => {
    if (item.id == v) {
      res = item.status;
    }
  });
  return res;
});

const computed_reward_list = computed(() => {
  let res = [];
  res = state.value.normal_award_list.sort((a, b) => {
    return (
      activity_config.value.item_data[b.item_id].is_gold -
      activity_config.value.item_data[a.item_id].is_gold
    );
  });
  return res;
});

const is_full = computed(() => {
  if (state.value) {
    return state.value.backpack.length >= 4;
  } else {
    return false;
  }
});

const is_gold_full = computed(() => {
  if (state.value) {
    return state.value.gold_backpack.length >= 2;
  } else {
    return false;
  }
});

const tips_info = ref(null);
function handle_show(id, id2) {
  is_tips.value = true;
  tips_id.value = id;
  add_id.value = id2;
  tips_info.value = encodeText(computed_tips.value.desc);
}

// 放入背包
async function handle_set() {
  let backpack = [];
  state.value.backpack.map((item) => {
    backpack.push(item.id);
  });

  let is_gold = false;
  if (computed_tips.value.is_gold == 1) {
    is_gold = true;
  }
  let gold_backpack = [];
  state.value.gold_backpack.map((item) => {
    gold_backpack.push(item.id);
  });
  if (is_gold) {
    if (is_gold_full.value) {
      eventEmitter.emit('toast', {
        text: '当前今格已被放满，无法放入',
      });
    } else {
      gold_backpack = [...gold_backpack, add_id.value];
    }
  } else {
    console.log('不是金色');
    if (is_full.value) {
      if (is_gold_full.value) {
        eventEmitter.emit('toast', {
          text: '当前提取奖励已满，无法放入',
        });
      } else {
        gold_backpack = [...gold_backpack, add_id.value];
      }
    } else {
      backpack = [...backpack, add_id.value];
    }
  }

  const res = await set_bonus({
    backpack: backpack,
    gold_backpack: gold_backpack,
  });
  if (res.code == 1) {
    eventEmitter.emit('toast', {
      text: '放入背包成功',
    });
    execute();
    is_tips.value = false;
  } else {
     eventEmitter.emit('toast', {
      text: res.errorMsg,
    });
  }
}

// 拿出背包
async function handle_un_set() {
  let ids = [];
  state.value.backpack.map((item) => {
    ids.push(item.id);
  });

  let gold_ids = [];
  state.value.gold_backpack.map((item) => {
    gold_ids.push(item.id);
  });

  let index = ids.findIndex((value) => {
    return value == add_id.value;
  });
  if (index !== -1) {
    ids.splice(index, 1);
  }

  let index2 = gold_ids.findIndex((value) => {
    return value == add_id.value;
  });

  if (index2 !== -1) {
    gold_ids.splice(index2, 1);
  }

  const res = await set_bonus({ backpack: ids, gold_backpack: gold_ids });
  if (res.code == 1) {
    eventEmitter.emit('toast', {
      text: '取出背包成功',
    });
    is_tips.value = false;
    execute();
  } else {
    eventEmitter.emit('toast', {
      text: res.errorMsg,
    });
  }
}

function receiveHongbao() {
  const ispass = beforeCheck();
  if (!ispass) return;
  eventEmitter.emit('showHongbaoModal');
}

function beforeCheck() {
  if (!(isWeChat.value || isMiniProgram.value)) {
    eventEmitter.emit('showCommomTipModal', 'openInwx');
    return false;
  }
  if (!login_status.value) {
    eventEmitter.emit('login');
    return false;
  }
  if (!!error_codemsg.value) {
    eventEmitter.emit('toast', {
      text: error_codemsg.value,
    });
    return false;
  }
  return true;
}

let is_red = shallowRef(false);
async function get_dot(id) {
  const res = await get_red_data(id);
  if (res.code == 1) {
    is_red.value = res.data.reward_popup;
  }
}

watch(is_show, async (v) => {
  if (v) {
    execute();
  } else {
    await get_set_last_time(init_data.id);
    get_dot(init_data.id);
  }
});

function handle_show_together() {
  if (state.value.share_award.status == 0) {
    eventEmitter.emit('show_together', state.value.share_award);
  } else if (state.value.share_award.status == 1) {
    Dialog.success = true;
  } else if (state.value.share_award.status == 2) {
    Dialog.fail = true;
  }
  post_set_share_reward_red_dot({
    share_id: init_data.id,
    share_reward_id: state.value.share_award.id,
  });
}

function showModalHandle() {
  if (!login_status.value) {
    eventEmitter.emit('login');
    return false;
  }
  if (!!error_codemsg.value) {
    eventEmitter.emit('toast', {
      text: error_codemsg.value,
    });
    return false;
  }
  is_show.value = true;
}

onMounted(() => {
  eventEmitter.on('show_reward', () => {
    is_show.value = true;
  });
});

// 红点
watch(init_data, (v) => {
  if (v) {
    get_dot(v.id);
  }
});

// 问号tips
let is_wenhao_tips = shallowRef(false);
</script>
<style lang="scss" scoped>
.rule {
  position: fixed;
  right: 0px;
  top: 280px;
  z-index: 99;
  color: #e8e8e8;
  font-size: 20px;
}

.reward-hongdian {
  position: fixed;
  right: 0px;
  top: 280px;
  z-index: 99;
}

.reward-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  @include bg('db_9');

  h1 {
    font-size: 40px;
    color: #fff;
  }
}

.tips-container {
  @include bg('tips');
}

.beibao {
  // @include bg('db_11');
}

.jiangli {
  // @include bg('db_10');
}

.jpdi {
  width: 82px;
  height: 82px;
}

.zhedang {
  position: absolute;
  bottom: 0;
  font-size: 20px;
  width: 70px;
  height: 30px;
  background: #000000a8;
}

.jiangli-list {
  @include bg('xiadi');
}

.tips-header {
  width: 100%;
  height: 110px;
  font-size: 28px;
  color: #9c9486;
  position: relative;
  top: 5px;
}

.tips-content {
  height: 430px;
  width: 98%;
  // border: #e8e8e8 1px solid;
  font-size: 24px;
  color: #d8d8d8;
  padding: 10px 20px;
}

.tongxiang-hongbao {
  position: absolute;
  bottom: -70px;
  left: 20px;
}

.tixian {
  position: absolute;
  bottom: -28px;

  &.noReveive {
    font-size: 16px;
  }
}

.tongxiang-container {
  width: 300px;
  height: 400px;
}

.tongxiang-title {
  position: relative;
  top: -90px;
}

.wuqiTips-item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  // margin: 10px 0px;
}

.beibao-show {
  @include bg('shangdi');
}

.tips-name {
  position: relative;
  top: -20px;
}

.reward-btn {
  position: relative;
  top: 100px;
}

.reward-item-dot {
  position: absolute;
  top: 0;
  right: 0;
}

.wenhao-tips {
  position: absolute;
  left: 160px;
  top: 30px;
  font-size: 20px;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.tongxiang-hongdian{
  right:5px
}
</style>
